<template>
    <!-- 公共按钮 -->
    <div>
        <!-- 搜索弹框 -->
        <el-dialog :visible.sync="vis" title="产品编码" width="40%" :close-on-click-modal="false">
            <el-table
                    header-row-class-name="headerclass"
                    stripe
                    :data="dataSet"
                    border
                    max-height="500"
                    size="mini"
                    :highlight-current-row="true"
                    style="width: 100%; margin-top: 20px"
                    ref="table"
            >
                <el-table-column show-overflow-tooltip prop="productname" label="品名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productmodel" label="型号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productspecs" label="规格"></el-table-column>
                <el-table-column show-overflow-tooltip prop="productcode" label="产品唯一编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="retailprice" label="零售价" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="provincialprice" label="省代价格" align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="cityprice" label="市代价格" align="right"></el-table-column>
                <!--<el-table-column show-overflow-tooltip prop="dealeriid" label="经销商ID"></el-table-column>-->
                <el-table-column show-overflow-tooltip prop="status" label="状态">
                    <template scope="scope">
                        <span>{{expstatus(scope.row.status)}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="trackingnum" label="快递单号"></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="20">
						<!--<el-pagination
                                @current-change="handleSizeChange"
                                @size-change="handleSizeChange"
                                small
                                layout="prev, pager, next, jumper"
                                :total="total"
                                :pager-count = "5"
                                class="pagesmall"
                        ></el-pagination>-->
                        <el-pagination
                                style="margin-top: 1em"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="SelectIndexs"
                                :page-sizes="[1000,1500, 2000, 2500, 3000, 3500,4000,4500,5000,5500,6000,6500,7000,7500,8000,8500,9000,9500,10000]"
                                :page-size="1000"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                        ></el-pagination>
					</el-col>
				</el-row>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'item',
        props: {
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dataSet: [],
                total: 0,
                pageSize: 1000,
                pageIndex: 1,
                SelectIndexs: 1,
                queryKey: '',
                cache_code: '',
                vis: this.isVisible, // 是否显示弹窗，
            };
        },

        mounted: function () {
            this.vis = this.isVisible;
        },
        methods: {
            clearInput(e,arr, total) {
                let that = this
                that.vis = e;
                that.dataSet = arr
                that.total = total
            },
            //修改页数
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
            },
            //跳页
            handleCurrentChange(val) {
                this.pageIndex = val
                this.SelectIndexs = val;
                this.getView();
            },
            expstatus(value){
                if(value == 0){
                    return '草稿'
                } else if(value == 1){
                    return '已使用'
                } else if(value == 2){
                    return '未使用'
                } else if(value == 3){
                    return '冻结'
                } else if(value == 4){
                    return '退货'
                } else if(value == 5){
                    return '赠送'
                } else {
                    return ''
                }
            },
        }
    };
</script>

<style>
    .contents {
        position: fixed;
        height: 60px;
        top: 0px;
        line-height: 60px;
        right: 7.5rem;
        z-index: 9999;
    }
</style>
